import { Pipe, PipeTransform } from '@angular/core';
import { ProductTypeCode } from '../../common/models/application-general.model';

@Pipe({
  standalone: false,
  name: 'productType'
})
export class ProductTypePipe implements PipeTransform {
  private types: { [key: string]: string } = {};

  constructor() {
    this.types[ProductTypeCode.fsd] = 'SD (Regular)';
    this.types[ProductTypeCode.sda] = 'SD Alternative';
    this.types[ProductTypeCode.sdi] = 'SD Installments';
    this.types[ProductTypeCode.sds] = 'SD Subscription';
    this.types[ProductTypeCode.umbrellaSda] = 'SD Alternative';
    this.types[ProductTypeCode.umbrellaSdi] = 'SD Installments';
  }

  transform(value: ProductTypeCode): string {
    return this.types[value] ?? 'Unknown';
  }
}
